import { styled } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';
import { SButtonProps } from '@setvi/shared/components/sbutton';
import {
  AIGradientIcon,
  ArrowUpwardIcon
} from '@setvi/shared/components/sicons';
import { AIGradientBgColor } from '../../../../../../styled';
import { formId } from '../../../text';

export const StyledButton = styled(SButton)({
  background: AIGradientBgColor,
  borderRadius: 120,
  maxHeight: 'max-content',
  fontWeight: 500,

  '&.Mui-disabled': {
    color: '#AFBAC6',
    background: '#EEF0F2',
    '& svg path': {
      fill: '#AFBAC6'
    }
  }
});

interface SubmitButtonProps extends Omit<SButtonProps, 'children'> {
  label?: string;
  expanded?: boolean;
}

export const ProductMatchSubmitButton = ({
  label = 'Find It',
  expanded = true,
  ...rest
}: SubmitButtonProps) => (
  <StyledButton
    form={formId}
    type="submit"
    {...(expanded && {
      startIcon: <AIGradientIcon />,
      endIcon: (
        <ArrowUpwardIcon
          fill="#fff"
          style={{ rotate: '90deg', fontSize: 11 }}
        />
      )
    })}
    {...rest}>
    {expanded ? (
      label
    ) : (
      <ArrowUpwardIcon fill="#fff" style={{ rotate: '90deg', fontSize: 11 }} />
    )}
  </StyledButton>
);
